module.exports = __webpack_public_path__ + "static/media/lens_classic-Bright.ca0468ad.png";